import React, { useState, useEffect } from 'react';
import {
  Button,
  Modal,
  Container,
  Row,
  Col,
  Form,
  Badge
} from 'react-bootstrap/';
import {
  SortableContainer,
  SortableElement,
  SortableHandle
} from 'react-sortable-hoc';
import arrayMove from 'array-move';
import InputColor from 'react-input-color';
import PropTypes from 'prop-types';
import { Switch } from 'pretty-checkbox-react';
import AlertMsg from '../../components/AlertMsg';
import InputMask from 'react-input-mask';

import { useSelector, useDispatch } from 'react-redux';
import { editDashboards } from '../../redux/actions/dashboards';

import tableFontSizes from '../../config-panel-dash/tableFontSizes';
import hourFields from '../../config-panel-dash/hourFields';
import noLimitConfigFields from '../../config-panel-dash/noLimitConfigFields';

const DragHandle = SortableHandle(() => (
  <span>
    <i className="fas fa-bars sort-hand"> </i>
  </span>
));

const SortableList = SortableContainer(props => {
  const { items, setShowConfig, setEditingField, setRowOrder } = props;

  const handleChangeVisibleTableColumn = evt => {
    evt.preventDefault();
    const { name, checked } = evt.target;
    const newItems = items.map(item =>
      item.id === name ? { ...item, visible: checked } : { ...item }
    );
    setRowOrder([...newItems]);
  };

  const SortableItem = SortableElement(({ item }) => {
    const handleClickConfig = field => {
      setEditingField(field);
      setShowConfig(true);
    };

    const { id, text, title, visible } = item;

    return (
      <li className="sortable-item">
        <Container>
          <Row>
            <Col xs={6} sm={8} className="m-auto">
              <DragHandle />
              <span className="name-field" title={title}>
                {text}
              </span>
            </Col>
            <Col xs={3} sm={2} className="m-auto">
              <div className="checkbox" title="Exibir / Ocultar coluna">
                <Switch
                  type="checkbox"
                  color="success"
                  name={id}
                  onChange={handleChangeVisibleTableColumn}
                  checked={visible}
                />
              </div>
            </Col>
            <Col xs={3} sm={2} className="m-auto">
              <Button
                title="Configuração de limites desta coluna"
                variant="outline-info"
                onClick={() => handleClickConfig(item)}
              >
                <i className="fas fa-sliders-h"></i>
              </Button>
            </Col>
          </Row>
        </Container>
      </li>
    );
  });

  return (
    <ul className="sortable-list">
      {items.map((item, index) => (
        <SortableItem key={`item-${item.id}`} index={index} item={item} />
      ))}
    </ul>
  );
});

function ModalEditTablesDash (props) {
  const hourTransform = value => {
    const hour = String(value);
    let hr = '';
    const qtdDigits = hour.length;
    switch (qtdDigits) {
      case 1:
        hr = '00000' + hour;
        break;
      case 2:
        hr = '0000' + hour;
        break;
      case 3:
        hr = '000' + hour;
        break;
      case 4:
        hr = '00' + hour;
        break;
      case 5:
        hr = '0' + hour;
        break;
      default:
        hr = hour;
        break;
    }
    return hr.length === 6
      ? `${hr.charAt(0)}${hr.charAt(1)}:${hr.charAt(2)}${hr.charAt(
          3
        )}:${hr.charAt(4)}${hr.charAt(5)}`
      : '';
  };
  const initialConfig = {
    backColorHeader: '#000', // Cor backcolor cabeçalho
    fontColorHeader: '#000', // Cor fontcolor da cabeçalho
    limit1Color: '#000',
    limit1Value: 0,
    limit2Color: '#000',
    limit2Value: 0,
    limit3Color: '#000',
    limit3Value: 0
  };
  const dispatch = useDispatch();
  const [rowOrder, setRowOrder] = useState([]);
  const dashboards = useSelector(state => state.dashboards);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const orderItems = rows => arrayMove(rows, oldIndex, newIndex);
    setRowOrder(orderItems);
  };

  const { showEditTable, setShowEditTable, currentDash, editingPanel } = props;
  const [showConfig, setShowConfig] = useState(false);
  const [config, setConfig] = useState({ ...initialConfig });
  const [data, setData] = useState({
    name: '',
    fontHeader: '16',
    fontContent: '16'
  });
  const [copySucess, setCopySucess] = useState(false);
  const [pasteSucess, setPasteSucess] = useState(false);
  const [errorLimitConfig, setErrorLimitConfig] = useState(false);

  const handleClose = () => setShowEditTable(false);
  const handleCloseConfig = () => setShowConfig(false);
  const onEnter = () => {
    setRowOrder([...editingPanel.fields]);
    setData({ ...data, ...editingPanel });
  };
  const [editingField, setEditingField] = useState({});

  const handleClickSaveConfigGlobal = () => {
    const dash = {
      ...currentDash,
      items: currentDash.items.map(item =>
        item.i !== data.i ? { ...item } : { ...data, fields: [...rowOrder] }
      )
    };
    dispatch(editDashboards(dash));
  };

  const handleClickSaveConfigLimit = () => {
    const { id } = editingField;
    const configFields = data.configFields.filter(
      config => Object.keys(config)[0] !== id
    );
    const l1 = String(config.limit1Value).replace(/:|_/g, '');
    const l2 = String(config.limit2Value).replace(/:|_/g, '');
    const l3 = String(config.limit3Value).replace(/:|_/g, '');
    const conf = {
      ...config,
      limit1Value: l1 ? parseInt(l1) : 0,
      limit2Value: l2 ? parseInt(l2) : 0,
      limit3Value: l3 ? parseInt(l3) : 0
    };
    if (
      !!l1 &&
      !!l2 &&
      !!l3 &&
      ((conf.limit1Value === 0 &&
        conf.limit2Value === 0 &&
        conf.limit3Value === 0) ||
        (conf.limit1Value !== conf.limit2Value &&
          conf.limit2Value !== conf.limit3Value &&
          conf.limit3Value !== conf.limit1Value))
    ) {
      const dash = {
        ...currentDash,
        items: currentDash.items.map(item =>
          item.i !== data.i
            ? { ...item }
            : {
              ...data,
              fields: [...rowOrder],
              configFields: configFields.concat([{ [id]: conf }])
            }
        )
      };
      const hourRegex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
      if (hourFields.includes(editingField.id)) {
        if (
          hourRegex.test(config.limit1Value) &&
          hourRegex.test(config.limit2Value) &&
          hourRegex.test(config.limit3Value)
        ) {
          setErrorLimitConfig(false);
          dispatch(editDashboards(dash));
        } else {
          setErrorLimitConfig(true);
        }
      } else {
        setErrorLimitConfig(false);
        dispatch(editDashboards(dash));
      }
    } else {
      setErrorLimitConfig(true);
    }
  };

  const handleChange = evt => {
    evt.preventDefault();
    if (evt.target.getAttribute('number') === 'on') {
      if (evt.target.value.match(/^\d+$/) || evt.target.value === '') {
        setData({
          ...data,
          [evt.target.name]: evt.target.value
        });
      } else {
        evt.target.value = data[evt.target.name];
      }
    } else {
      const isCheckbox = evt.target.type === 'checkbox';
      setData({
        ...data,
        [evt.target.name]: isCheckbox ? evt.target.checked : evt.target.value
      });
    }
  };

  const handleClickSelectVisibleAll = () => {
    const newState = rowOrder.find(row => !row.visible);
    if (newState) {
      const newRows = rowOrder.map(item =>
        item.visible ? { ...item } : { ...item, visible: true }
      );
      setRowOrder([...newRows]);
    } else {
      const newRows = rowOrder.map(item =>
        item.visible ? { ...item, visible: false } : { ...item }
      );
      setRowOrder([...newRows]);
    }
  };

  useEffect(() => {
    if (showConfig && data) {
      const { id } = editingField;
      const configField = data.configFields.find(config =>
        Object.keys(config).includes(id)
      );
      if (configField) {
        if (hourFields.includes(id)) {
          setConfig({
            ...config,
            ...configField[id],
            limit1Value: hourTransform(configField[id].limit1Value),
            limit2Value: hourTransform(configField[id].limit2Value),
            limit3Value: hourTransform(configField[id].limit3Value)
          });
        } else {
          setConfig({ ...config, ...configField[id] });
        }
      } else if (hourFields.includes(id)) {
        setConfig({
          ...config,
          limit1Value: '00:00:00',
          limit2Value: '00:00:00',
          limit3Value: '00:00:00'
        });
      }
    } else {
      setConfig({ ...initialConfig });
      setErrorLimitConfig(false);
    }
  }, [showConfig, data.configFields]);

  const handleChangeColor = (color, field) => {
    const { r, g, b, a, hex } = color;
    if (
      !isNaN(r) &&
      !isNaN(g) &&
      !isNaN(b) &&
      !isNaN(a) &&
      (hex.length === 4 || hex.length === 7)
    ) {
      setConfig({ ...config, [field]: hex });
    }
  };

  const handleChangeLimit = evt => {
    evt.preventDefault();
    if (evt.target.value === '' || evt.target.getAttribute('hour') === 'on') {
      setConfig({
        ...config,
        [evt.target.name]: evt.target.value
      });
    } else if (evt.target.value.match(/^\d+$/)) {
      const value = parseInt(evt.target.value, 10);
      setConfig({
        ...config,
        [evt.target.name]: value > -1 ? value : 0
      });
    } else {
      evt.target.value = config[evt.target.name];
    }
  };

  const handleClickConfigDefault = () => {
    if (hourFields.includes(editingField.id)) {
      const conf = {
        ...initialConfig,
        limit1Value: '00:00:00',
        limit2Value: '00:00:00',
        limit3Value: '00:00:00'
      };
      setConfig({ ...conf });
    } else {
      setConfig({ ...initialConfig });
    }
  };

  const handleClickCopyConfig = () => {
    if (hourFields.includes(editingField.id)) {
      const l1 = String(config.limit1Value).replace(/:|_/g, '');
      const l2 = String(config.limit2Value).replace(/:|_/g, '');
      const l3 = String(config.limit3Value).replace(/:|_/g, '');
      const conf = {
        ...config,
        limit1Value: l1 ? parseInt(l1) : 0,
        limit2Value: l2 ? parseInt(l2) : 0,
        limit3Value: l3 ? parseInt(l3) : 0
      };
      localStorage.setItem('config', JSON.stringify(conf));
    } else {
      localStorage.setItem('config', JSON.stringify(config));
    }
    localStorage.setItem('copyedField', editingField.id);
    setCopySucess(true);
    setTimeout(() => {
      setCopySucess(false);
    }, 1600);
  };

  const handleClickPasteConfig = () => {
    try {
      const conf = JSON.parse(localStorage.getItem('config'));
      if (hourFields.includes(editingField.id)) {
        setConfig({
          ...conf,
          limit1Value: hourTransform(conf.limit1Value),
          limit2Value: hourTransform(conf.limit2Value),
          limit3Value: hourTransform(conf.limit3Value)
        });
      } else {
        setConfig({ ...conf });
      }
      setPasteSucess(true);
      setTimeout(() => {
        setPasteSucess(false);
      }, 1600);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <Modal
        show={showEditTable}
        onEnter={onEnter}
        onHide={() => setShowEditTable(false)}
        onExited={handleCloseConfig}
        dialogClassName="modal-auto-width"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Body className="modal-body-responsive pb-1">
          {dashboards.editSuccess && (
            <AlertMsg type="success" msg="Tabela atualizada com sucesso" />
          )}
          {dashboards.editError && (
            <AlertMsg type="danger" msg="Falha durante atualização da tabela" />
          )}
          {!dashboards.editSuccess && !dashboards.editError && (
            <AlertMsg type="info" msg="Área configuração de tabela" />
          )}
          <h3 className="mb-2 ml-2">
            {editingPanel && editingPanel.type}:{' '}
            <span className="badge badge-dark">
              {editingPanel && editingPanel.name}
            </span>
          </h3>
          <Container className="container-fluid">
            <Row>
              {!showConfig && (
                <Col sm={12} md={12} lg={12}>
                  <Row>
                    <Col sm={4}>
                      <Form.Group>
                        <Form.Label>Nome do Painel</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          value={data.name}
                          onChange={handleChange}
                          autoComplete="off"
                        />
                      </Form.Group>
                    </Col>
                    <Col sm={4}>
                      <Form.Group>
                        <Form.Label>Fonte Cabeçalho</Form.Label>
                        <Form.Control
                          as="select"
                          name="fontHeader"
                          value={data.fontHeader}
                          onChange={handleChange}
                        >
                          {tableFontSizes.map(fontSize => (
                            <option key={fontSize} value={fontSize}>
                              {fontSize}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col sm={4}>
                      <Form.Group>
                        <Form.Label>Fonte Conteúdo</Form.Label>
                        <Form.Control
                          as="select"
                          name="fontContent"
                          value={data.fontContent}
                          onChange={handleChange}
                        >
                          {tableFontSizes.map(fontSize => (
                            <option key={fontSize} value={fontSize}>
                              {fontSize}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <h5 className="pt-2">Tabela&nbsp;</h5>
                  <p>Clique e arraste para ordernar a posição das colunas.</p>

                  <SortableList
                    items={rowOrder}
                    setRowOrder={setRowOrder}
                    onSortEnd={onSortEnd}
                    helperClass="sortable-helper"
                    showConfig={showConfig}
                    setShowConfig={setShowConfig}
                    setEditingField={setEditingField}
                    useDragHandle
                  />
                  <Button
                    className="btn-mark"
                    variant={`${
                      rowOrder.find(row => !row.visible) ? 'success' : 'danger'
                    }`}
                    onClick={handleClickSelectVisibleAll}
                  >
                    {`${
                      rowOrder.find(row => !row.visible)
                        ? 'Selecionar'
                        : 'Deselecionar'
                    }`}{' '}
                    todos
                  </Button>
                </Col>
              )}

              {showConfig && (
                <Col sm={12} md={12} lg={12}>
                  <Row>
                    <Col sm={12} className="config-field-title">
                      <h3>
                        <Badge variant="dark">{editingField.text}</Badge>
                      </h3>
                      <label>{editingField.title}</label>
                    </Col>
                  </Row>
                  <Row className="pt-2">
                    <Col sm={6}>
                      <label>Cor do Fundo Cabeçalho</label>
                      <Row>
                        <Col xs={3}>
                          <div>
                            <InputColor
                              name="backColorHeader"
                              className="picker-color"
                              initialHexColor={config.backColorHeader}
                              onChange={color =>
                                handleChangeColor(color, 'backColorHeader')
                              }
                              placement="bottom"
                            />
                          </div>
                        </Col>
                        <Col xs={9}>
                          <input
                            type="text"
                            className="form-control limit"
                            value={
                              config.backColorHeader.length > 4
                                ? config.backColorHeader
                                : ''
                            }
                            readOnly={true}
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col sm={6}>
                      <label>Cor da Fonte Cabeçalho</label>
                      <Row>
                        <Col xs={3}>
                          <div>
                            <InputColor
                              name="fontColorHeader"
                              className="picker-color"
                              initialHexColor={config.fontColorHeader}
                              onChange={color =>
                                handleChangeColor(color, 'fontColorHeader')
                              }
                              placement="bottom"
                            />
                          </div>
                        </Col>
                        <Col xs={9}>
                          <input
                            type="text"
                            className="form-control limit"
                            value={
                              config.fontColorHeader.length > 4
                                ? config.fontColorHeader
                                : ''
                            }
                            readOnly={true}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  {!noLimitConfigFields.includes(editingField.id) && (
                    <div>
                      <Row>
                        <Col xs={6}>
                          <label>Limite 1</label>
                          <div className="input-group">
                            {hourFields.includes(editingField.id) ? (
                              <InputMask
                                name="limit1Value"
                                mask="99:99:99"
                                hour="on"
                                value={config.limit1Value}
                                className="form-control"
                                placeholder="00:00:00"
                                onChange={handleChangeLimit}
                              />
                            ) : (
                              <input
                                type="text"
                                name="limit1Value"
                                className="form-control limit"
                                onChange={handleChangeLimit}
                                autoComplete="off"
                                value={
                                  !config.limit1Value ||
                                  parseInt(config.limit1Value) > -1
                                    ? config.limit1Value
                                    : 0
                                }
                              />
                            )}
                          </div>
                        </Col>
                        <Col xs={6}>
                          <label>Cor 1</label>
                          <Row>
                            <Col sm={3} xs={4}>
                              <div>
                                <InputColor
                                  name="limit1Color"
                                  className="picker-color"
                                  initialHexColor={config.limit1Color}
                                  onChange={color =>
                                    handleChangeColor(color, 'limit1Color')
                                  }
                                  placement="bottom"
                                />
                              </div>
                            </Col>
                            <Col sm={9} xs={8}>
                              <input
                                type="text"
                                className="form-control limit"
                                value={
                                  config.limit1Color.length > 4
                                    ? config.limit1Color
                                    : ''
                                }
                                readOnly={true}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={6}>
                          <label>Limite 2</label>
                          <div className="input-group">
                            {hourFields.includes(editingField.id) ? (
                              <InputMask
                                name="limit2Value"
                                mask="99:99:99"
                                hour="on"
                                value={config.limit2Value}
                                className="form-control"
                                placeholder="00:00:00"
                                onChange={handleChangeLimit}
                              />
                            ) : (
                              <input
                                type="text"
                                name="limit2Value"
                                className="form-control limit"
                                onChange={handleChangeLimit}
                                autoComplete="off"
                                value={
                                  !config.limit2Value ||
                                  parseInt(config.limit2Value) > -1
                                    ? config.limit2Value
                                    : 0
                                }
                              />
                            )}
                          </div>
                        </Col>
                        <Col xs={6}>
                          <label>Cor 2</label>
                          <Row>
                            <Col sm={3} xs={4}>
                              <div>
                                <InputColor
                                  name="limit2Color"
                                  className="picker-color"
                                  initialHexColor={config.limit2Color}
                                  onChange={color =>
                                    handleChangeColor(color, 'limit2Color')
                                  }
                                  placement="bottom"
                                />
                              </div>
                            </Col>
                            <Col sm={9} xs={8}>
                              <input
                                type="text"
                                className="form-control limit"
                                value={
                                  config.limit2Color.length > 4
                                    ? config.limit2Color
                                    : ''
                                }
                                readOnly={true}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={6}>
                          <label>Limite 3</label>
                          <div className="input-group">
                            {hourFields.includes(editingField.id) ? (
                              <InputMask
                                name="limit3Value"
                                mask="99:99:99"
                                hour="on"
                                value={config.limit3Value}
                                className="form-control"
                                placeholder="00:00:00"
                                onChange={handleChangeLimit}
                              />
                            ) : (
                              <input
                                type="text"
                                name="limit3Value"
                                className="form-control limit"
                                onChange={handleChangeLimit}
                                autoComplete="off"
                                value={
                                  !config.limit3Value ||
                                  parseInt(config.limit3Value) > -1
                                    ? config.limit3Value
                                    : 0
                                }
                              />
                            )}
                          </div>
                        </Col>
                        <Col xs={6}>
                          <label>Cor 3</label>
                          <Row>
                            <Col sm={3} xs={4}>
                              <div>
                                <InputColor
                                  name="limit3Color"
                                  className="picker-color"
                                  initialHexColor={config.limit3Color}
                                  onChange={color =>
                                    handleChangeColor(color, 'limit3Color')
                                  }
                                  placement="bottom"
                                />
                              </div>
                            </Col>
                            <Col sm={9} xs={8}>
                              <input
                                type="text"
                                className="form-control limit"
                                value={
                                  config.limit3Color.length > 4
                                    ? config.limit3Color
                                    : ''
                                }
                                readOnly={true}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  )}
                  <Row className="pt-2 pb-2 text-center">
                    <Col>
                      <Button
                        variant="dark"
                        onClick={handleClickCopyConfig}
                        style={{ cursor: 'copy' }}
                      >
                        <i className="fas fa-copy" />
                        <p className="m-0">Copiar</p>
                      </Button>
                    </Col>
                    <Col>
                      <Button variant="info" onClick={handleClickConfigDefault}>
                        <i className="fas fa-undo" />
                        <p className="m-0">Padrão</p>
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        variant="dark"
                        onClick={handleClickPasteConfig}
                        disabled={
                          !localStorage.getItem('config') ||
                          localStorage.getItem('copyedField') ===
                            editingField.id
                        }
                        style={{ cursor: 'context-menu' }}
                      >
                        <i className="fas fa-paste" />
                        <p className="m-0">&nbsp;Colar&nbsp;</p>
                      </Button>
                    </Col>
                  </Row>
                </Col>
              )}
            </Row>
            {showConfig && copySucess && (
              <p className="text-center m-0">
                <small className="text-success font-weight-bold">
                  Configuração copiada para área de transferência
                </small>
              </p>
            )}
            {showConfig && pasteSucess && (
              <p className="text-center m-0">
                <small className="text-success font-weight-bold">
                  Configuração copiada com sucesso
                </small>
              </p>
            )}
            {showConfig && errorLimitConfig && (
              <p className="text-center m-0">
                <small className="text-danger font-weight-bold">
                  Configure cada limite corretamente
                </small>
              </p>
            )}
            {showConfig && !copySucess && !pasteSucess && !errorLimitConfig && (
              <p className="text-center m-0">
                <small>&nbsp;</small>
              </p>
            )}
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={showConfig ? handleCloseConfig : handleClose}
          >
            {showConfig && (
              <span>
                <i className="fas fa-arrow-left" /> Voltar
              </span>
            )}
            {!showConfig && (
              <span>
                <i className="fas fa-times" /> Fechar
              </span>
            )}
          </Button>
          <Button
            variant="primary"
            onClick={
              showConfig
                ? handleClickSaveConfigLimit
                : handleClickSaveConfigGlobal
            }
            disabled={dashboards.isFetching || !data.name.trim().length}
          >
            <span>
              <i className="fas fa-save" /> Salvar
            </span>
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

ModalEditTablesDash.propTypes = {
  showEditTable: PropTypes.bool,
  setShowEditTable: PropTypes.func,
  currentDash: PropTypes.object,
  editingPanel: PropTypes.object
};

export default ModalEditTablesDash;
